<template>
<transition name="slide" appear>
    <div class="modal" v-if="visible">
        <div class="item-info">
            <div class="collect">
                <button class="add" v-if=!checkCart() @click="addItem(collectables[iden].id)">
                    <img src="/images/ui/ui_collection-add.png" alt="Add to Collection">
                </button>
                <button class="remove" v-else @click="removeItem(collectables[iden])">
                    <img src="/images/ui/ui_collection-remove.png" alt="Remove from Collection">
                </button>
            </div>
            <img :src="collectables[iden].image" :alt="collectables[iden].name">
            <!-- <p>{{ collectables[iden].name }}</p> -->
            <!-- <p>{{ collectables[iden].description }}</p> -->
        </div>

        <div class="audio-player">
            <AudioPlayer v-bind:audioSrc="this.collectables[this.iden].audio" />
        </div>

        <!-- <p><a :href="collectables[iden].link" target="_blank">Item Page</a></p> -->
        <button class="close" @click="toggleModalParent">
            <img src="/images/ui/ui_close.png" alt="Close Collection View">
        </button>
    </div>
</transition>
</template>

<script>
import {
    getCartContents,
    findDiscoveredById
} from "@/store/index.js"
import AudioPlayer from "@/components/AudioPlayer";
import {
    bus
} from "@/main";

export default {
    name: "ArtifactDetails",
    components: {
        AudioPlayer
    },
    props: {
        iden: Number,
    },
    data() {
        return {
            visible: false,

        }
    },
    methods: {
        addItem(id) {
            this.$store.dispatch("addItem", id);
        },
        removeItem(index) {
            this.$store.dispatch("removeItem", index);
        },
        toggleModalParent() {
            this.$emit('button', 'displayModal')
        },
        toggleVisibility(id) {
            this.visible = !this.visible
            if (!this.visible) return

            if (id !== findDiscoveredById(id)) {
                this.$store.dispatch("discoverItem", id);
            }

            setTimeout(this.emitAudioObject.bind(this), 250)

        },
        // emitting into AudioPlayer on appearance
        emitAudioObject() {
            bus.$emit("playAudio", true)

        },
        checkCart() {
            return getCartContents().includes(this.collectables[this.iden])
        },
    },

    mounted() {},

    created() {
        this.visible = false
    },

    computed: {
        collectables() {
            return this.$store.getters.collectables;
        },
    },
}
</script>

<style scoped>
.modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: calc(100% - (.3em * 2));
    padding: .3em;
    background-color: var(--modal-back);
    display: flex;
    justify-content: space-between;
    z-index: 5;
    border-top: 1px solid var(--darkest);
}

.item-info {
    display: flex;
    align-items: center;
}

.item-info img {
    height: 57px;
    width: 57px;
    padding: .25em;
}

.item-info p {
    display: inline-block;
    padding-left: .75em;
}

.audio-player {
    display: flex;
    align-items: center;
    width: 75%;
}

/* ICON COLLECT BUTTON */
.collect button {
    background-color: var(--modal-back);
    display: block;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    cursor: pointer;
    outline: inherit;
    width: 57px;
    height: 57px;
    line-height: 1.15;
    padding: 0;
    margin: 0;
    border-radius: 5px;
}

.collect button img {
    padding: 0;
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: block;
}

button.close {
    padding: 0 1em;
    font: inherit;
    font-size: 2em;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;
    width: 1.75em;
}

.close img {
    padding: 0;
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: block;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform .5s;
}

.slide-enter,
.slide-leave-to {
    transform: translateY(100%);
}

@media screen and (min-width: 660px) {
    .modal {
        max-height: 80vh;
    }
}
</style>
